import { TextInput } from '@intellecteu/common-ui';
import { Field } from '../ui/form/field';
import { PruneUtcDateTooltip } from '../prune-utc-date-tooltip';

import s from './styles.module.scss';

export const Backups = () => {
  return (
    <div className={s.scheduleBackups}>
      <Field
        component={TextInput}
        id="cron"
        name="cron"
        label="Cron"
        tooltipText={<PruneUtcDateTooltip entity="backups" />}
        tooltipMaxWidth={215}
      />

      <Field component={TextInput} id="maxBackups" name="maxBackups" label="Max backup number" type="number" />
    </div>
  );
};
